

































import {
  format, parse, sub,
} from 'date-fns';
import Vue from 'vue';
import { VDatePicker } from 'vuetify/lib';

export default Vue.extend({

  components: {
    VDatePicker,
  },
  data() {
    return {
      dates: [] as string[],
      menu: false,
    };
  },

  computed: {
    computedDateFormatted(): string {
      if (!this.dates || this.dates.length === 0) { return ''; }
      if (this.dates.length === 1) {
        return format(parse(this.dates[0], 'yyyy-MM-dd', new Date()), 'MMM dd, yyyy');
      }

      const datesFormatted = [
        format(parse(this.dates[0], 'yyyy-MM-dd', new Date()), 'MMM dd, yyyy'),
        format(parse(this.dates[1], 'yyyy-MM-dd', new Date()), 'MMM dd, yyyy'),
      ];

      return `${datesFormatted[0]} - ${datesFormatted[1]}`;
    },
  },

  watch: {
    dates() {
      if (this.dates.length > 1) {
        this.$emit('dateUpdated', this.dates);
        this.menu = false;
      }
    },
  },

  mounted() {
    this.dates = this.getStartDates();
  },

  methods: {
    getStartDates(): string[] {
      const now = new Date();
      const lastMonth = sub(now, { days: 30 });
      return [
        format(lastMonth, 'yyyy-MM-dd'),
        format(now, 'yyyy-MM-dd'),
      ];
    },
  },
});
